<template>
  <div class="app-container">
    <div class="search-bar flex">
      <el-date-picker
        v-model="value1"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        value-format="yyyy-MM-dd"
        end-placeholder="结束日期"
        @change="dateChange"
      >
      </el-date-picker>
      <el-select v-model="listQuery.keyword_search" placeholder="操作类型">
        <el-option label="登录成功" value="登录成功"></el-option>
        <el-option label="登录失败" value="登录失败"> </el-option>
      </el-select>
      <!-- <el-button>导出日志</el-button>
            <el-button @click="deleteLogs">删除日志</el-button> -->
      <el-input
        v-model="listQuery.keyword_search"
        clearable
        style="width: 300px"
        width="300px"
        size="small"
        class="name-input"
        placeholder="请输入关键字"
      />
      <el-button size="small" style="margin-left: 10px" icon="el-icon-search" @click="onSearchClick"> 搜索 </el-button>
    </div>
    <br />
    <el-table v-loading="listLoading" :data="list" border style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column prop="admin_name" width="180" label="账号" align="center" />
      <el-table-column prop="operation" width="200" label="操作类型" align="center" />
      <el-table-column prop="explain" label="说明" align="center" />
      <el-table-column prop="create_time" label="操作时间" width="180" align="center" />

      <el-table-column prop="admin_ip" width="200" label="登录ip" align="center" />
    </el-table>
    <div class="page">
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page_index"
        :limit.sync="listQuery.page_size"
        @pagination="getList"
      />
    </div>
  </div>
</template>
<script>
import { getLogList, deleteLog } from "@/api/auth";
import Pagination from "@/components/Pagination";

export default {
  components: { Pagination },
  props: {
    userId: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      selected: [],
      value1: [],
      list: [],
      total: 0,
      listQuery: {
        page_index: 1,
        page_size: 10,
        // start_time: null,
        // end_time: null,
        keyword_search: "",
      },
      listLoading: false,
      userList: [],
    };
  },

  mounted() {
    this.getList();
  },
  methods: {
    setTime(val) {
      console.log(val);
    },
    handleSelectionChange(row) {
      this.selected = row;
    },
    // async deleteLogs(){
    //      if(this.selected.length==0){
    //          this.$message.warning('请选择要删除的日志')
    //          return
    //      }
    //      this.$confirm('确定要删除选中的日志吗？', '提示', {
    //          confirmButtonText: '确定',
    //          cancelButtonText: '取消',
    //          type: 'warning'
    //      }).then(() => {

    //      }).catch(() => {

    //      });

    //  },
    async getList() {
      this.listLoading = true;

      const data = { ...this.listQuery };

      const res = await getLogList(data).catch((error) => {
        this.list = [];
        this.total = 0;
        throw error;
      });
      this.listLoading = false;

      this.total = res.total;
      this.list = res.data;
    },
    handleSelect(e) {
      console.log(e);
    },
    querySearch(queryString, cb) {
      var userList = this.userList;
      var results = queryString ? userList.filter(this.createFilter(queryString)) : userList;
      cb(results.map((i) => ({ value: i })));
    },
    createFilter(queryString) {
      return (item) => {
        return item.toLowerCase().indexOf(queryString.toLowerCase()) >= 0;
      };
    },
    dateChange(val) {
      if (!val) {
        this.listQuery.start_time = "";
        this.listQuery.end_time = "";
        this.listQuery.page_index = 1;
        this.getList();
        return;
      }
      this.listQuery.start_time = val[0];
      this.listQuery.end_time = val[1];
      this.listQuery.page_index = 1;
      this.getList();
    },
    onSearchClick() {
      this.listQuery.page_index = 1;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.add {
  display: flex;
  align-items: center;
  .username-input {
    width: 300px;
    margin-left: 20px;
  }
}
.name-input {
  margin-left: 10px;
}
</style>
